import { createSelector } from 'reselect'

import { findPostPurchaseCheckout, isLEHotelItem } from 'lib/checkout/checkoutUtils'

/**
 * Leaf selector for debit-card merchant fee eligibility.
 * Kept out of paymentType so getMerchantFeeAmount can read it without the
 * getCheckoutTotalsView ↔ getMerchantFeeAmount ↔ paymentType cycle.
 */
export const shouldShowDebitCardMerchantFees = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => state.offer.offers,
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (cartItems, offers, postPurchaseMode) => {
    const hasFlashHotel = cartItems.some(item => {
      if (isLEHotelItem(item)) {
        const offer = offers[item.offerId]
        if (offer?.type === 'hotel') {
          return true
        }
      }
      return false
    })

    return hasFlashHotel && !postPurchaseMode
  },
)
